// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckBox_wrapper__vclFo","check-box":"CheckBox_check-box__DW7BN","dark":"CheckBox_dark__NCldi","light":"CheckBox_light__fvQ6W","label":"CheckBox_label__8PsnZ"};